export enum HubConnectionState {
  Connected = 'Connected',
  Connecting = 'Connecting',
  Reconnecting = 'Reconnecting',
  Reconnected = 'Reconnected',
  Disconnected = 'Disconnected',
}
